var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-signup',{style:(_vm.mobile ? 'padding-top: 30px;' : 'margin-top: 30px;')})}
var staticRenderFns = []

export { render, staticRenderFns }